module.exports = {
  language: {
    name: '中文',
    userName: '张天爱',
    noLogin: '请登录',
    onLogin:'请先登录',
    home: '网站首页',
    vote: '投票',
	shops:'商城',
    schedule: '关于我们',
    Exhibition: '展厅',
    Journalism: '游玩攻略',
    Shopping: '商城',
    my: '我的作品',
    sign: '报名',
    parsswordLogin: '密码登录',
    sms: '短信登录',
    phone: '请输入您的手机号',
    parssworld: '8-20位密码',
    login: '登录',
    code: '发送验证码',
    Resend: '重新发送',
    Forget: '忘记密码',
    register: '注册',
    next: '下一步',
    set: '8-20位密码',
    confirm: '确认密码',
    success: '您已经成功设置密码，请使用新密码登录',
    upload_success:'上传成功',
    must:'必填',
    Log: '马上登录',
    chines: '中文',
    Change: '修改密码',
    Retrieve: '找回密码',
    LoginSuccess: '登录成功',
    Registered: '注册会员',
    numbers: '8-20位密码',
    read: '我已阅读并接受',
    User: '用户协议',
    Privacy: '隐私政策',
    and: '和',
    about: '平遥古城景区',
    Registration: '参展报名',
    Account: '账号设置',
    yourname: '姓名',
    idcard: '身份证号',
    email: '电子邮箱',
    address: '收货地址',
    address_b:'地址',
    emails:'电话',
    uploadHead: '上传头像',
    submit: '保存',
    out: '退出登录',
    personal: '个人资料',
    work: '我的作品投票',
    upload: '无法上传',
    del: '无法删除',
    uploadVideo: '当前只能上传视频',
    successMessage: '请填写正确信息',
    phoneError: '手机号码有误，请重填',
    EmailError: '请输入正确的邮箱',
    idcardError: '身份证输入不合法',
    type: '报名类型',
    signType: '请选择报名类型',
    sign_type:'请先选择报名类型',

    photoUser: '摄影师',
    sex: '性别',
    sheng: '省份',
	sexMessage:'请选择性别',
    label:'展览标签',
    phoneNumber:'联系电话',
    resume:'艺术履历',
    Upload:'上传图片',
    add:'添加',
    place:'请选择',
    photographer:'添加摄影师',
    storage:'暂存',
    mechanism:'机构',
	id_src:'请上传头像',
    school:'院校',
    male:'男',
    female:'女',
    Photography :'摄影从来就是一种观念的表达,是从具象到“抽象”的过程。它将世界抽象化为一个具体的戏剧性的片段,或者说,瞬间。这使得“众创”成为某种可能.因为艺术创作的私密性与孤独性,即便是那些充满理性的、宏大叙事的作品,也只是描摹出创作者的私人轨迹,跟随着历史的脉络。',
    exhibition :'平遥国际摄影大展展览空间分为室内空间和室外空间，参展摄影师须服从PIP组委会对展览场地的统一安排；',
    Please:'报名表为中文版和英文版，请完整填写表格内容；',
    version :'参展摄影师需提供2寸个人肖像照电子版；',
    materials:'所有参展材料请提交至PIP邮箱：pip@vip.163.com；',
    group :'个展摄影师只可投稿一组作品，数量为10-15幅。',
    gezhan:'个展',
    cezhan:'策展',
    zhanting:'展厅',
    photographerjianjie:'摄影师简介',
	photoMessage:'请上传图片',
	country:'国家',
    ok:'确定',
    buy:'去购买',
    exhibitors:'添加参展人',
    works:'展览作品',
    PhotographerName:'摄影师',
    workphoto:'摄影师作品',
    uploader:'上传图片',
    Partners:'合作伙伴',
    Results:'查看投票结果',
    Rules:'投票规则',
    Jump:'跳转',
    Confirm:'确定',
    Back:'返回首页',
    Delete:'删除',
    Modify:'修改',
    pingyaoInfo:' “平遥古城景区官方服务平台”是平遥古城景区管理有限公司根据平遥古城自身特点，运用专业技术与手段，为景区自主研发的一款涵盖旅游全过程的全域旅游管理服务平台。平台集智慧管理、智慧营销、智慧服务为一体，通过整合吃、住、行、游、购、娱六要素资源、各监管部门入驻、平台提供维护和运转，融合成全域智慧旅游平台，打造多位一体的全域智慧旅游服务体系，实现“一平台结算、一站式服务、一键式投诉”，为政府提供全方位的旅游服务监督管理工具、为游客提供一站式便捷服务、为旅游服务者提供有效的支持。实现平遥旅游全面数字化管理、旅游数据资源聚集、旅游营销精准化分析，以景区资源带动平遥全域旅游消费和旅游经济提升，促进平遥旅游服务质量升级。',
    Guide:'景点购票',
    uploadWork:"上传作品",
    order:'我的订单',
    Return:'退货/换货',
    date:'选择日期',
    supported:'商城功能只在中文语言下支持',
    contact:"联系我们",
    exhibitionSign:"参展报名",
    pingyaoShow:"景点展示",
    aboutShow:"景区概况",
    yearShow:'节庆品牌',
    everyShow:'企业荣誉',
    downLoad:'点击下载',
    labelName:'文件夹标注名称',
    solo:'个展： 参展类别+地区+展览名称+姓名+联系方式',
    curator:'策展：策展+策展主题+策展姓名+联系方式',
    Organization:'机构团体展：地区+机构名称+策展人姓名+联系方式',
    PIPIntro:'公司简介',
    PIPIntroContent:'平遥国际摄影大展（PIP），始于2001年，由山西省委宣传部、山西省文化和旅游厅、晋中市委和晋中市人民政府共同主办；由平遥县委、平遥县人民政府和平遥古城国际摄影大展有限公司共同承办。每年举行一次，从2001年至2019年已经举行了19届。中国平遥国际摄影大展是一个具有中国传统文化特色的国际摄影展，按照国际惯例运行。每届大展都会有数百名中国和世界各地的优秀摄影师和摄影机构参展，来自世界各国各地十多万专业摄影家和业余摄影爱好者前来观看展览和参加各项活动。马克•吕布（法国）、何奈•布里（法国）、塞巴斯蒂奥•萨尔加多（巴西）、苏珊•梅塞勒斯（美国）、马丁•帕尔（美国）、马丁•弗兰克（美国）、尤金•理查兹（美国）、卢卡斯•朱丽安（意大利）、让-皮埃尔·拉丰（美国）、布鲁诺·巴贝（法国）等诸多国际摄影大师都曾在平遥展出作品，马格南图片社、美国联系图片社、美国国家地理杂志社、美国光圈基金会、法国《巴黎竞赛》、《PHOTO》杂志社、德国国家地理杂志社摄影机构也都在平遥举办过各种展览及活动。        平遥大展提倡多元化、国际化、专业化，各种题材、风格和表现手法的作品都可以在平遥展出，被誉为“国际摄影师展示自己的珍贵舞台”。大展还通过展览的形式，对中国摄影的不同种类、流派进行梳理，使得展览呈现更有条理，清晰的反映出当代中国摄影创作的水准。除了摄影展览外，摄影大展还为参加者安排了幻灯演示会、优秀摄影作品评奖、优秀摄影画册评奖、影像短片展、摄影大师讲习班、摄影论坛等活动。        作为一个尊重历史，崇敬摄影先驱者的国际摄影节，平遥国际摄影大展通过多种方式向摄影前辈致敬。2003年，组委会建立了“平遥国际摄影博物馆”，这也是中国第一个摄影博物馆。当年为中国新闻摄影的先驱者沙飞先生和吴印咸先生塑像，展出并收藏他们的作品。2004年，为世界风光摄影大师安塞尔•亚当斯（美国）和中国新闻摄影理论的先驱蒋齐生先生塑像，展出并收藏他们的作品。2005年，为著名战地摄影家罗伯特•卡帕（美国）和中国台湾摄影家郎静山先生塑像，展出并收藏他们的作品。2011年，平遥大展首次设立致敬展，用以向为中国摄影做出杰出贡献的摄影人致敬，已先后通过展览朱宪民、顾棣、张祖道、袁毅平、胡冰、侯波老摄影人的作品表达敬意，整理中国摄影史。        中国平遥国际摄影大展院校展是世界上规模最大的摄影教育成果展示，每年都吸引来自全世界的院校师生参展，2016年，共有80所国内外院校参加院校展。        中国平遥国际摄影大展是中国十大著名节庆之一，荣获“IFEA中国最具国际影响力十大节庆活动”奖，是当代摄影家最盛大的节日，是国际摄影艺术和中国摄影发展、引领各种摄影流派和顶级学术活动的重要展示平台。       平遥国际摄影大展，是世界上最大的摄影展示，最具国际影响力的节庆活动，全球摄影人的奥斯卡！',
    PIPFootprint:'平台简介',
    Australia:'澳大利亚',
    PingyaoCity:'平遥古城',
    PingyaoIntro:'平遥古城位于中国山西省黄上高原中部晋中盆地南端，距省会太原市100公里。古城的历史可以上溯到2700年前的西周宣武王时期(公元前827年~公元前782年) ,那时驻军为了抵御外敌的侵扰，在此筑了一座土城。 到比魏始光元年(公元424年)，平遥县作为县治所在地，延续至今。现在平遥古城的规模是明洪武三年(公元1370年)扩建的。平遥有着悠久的历史,早在新石器时代，人类就在这里繁衍生息。相传帝尧初封于陶，故平遥亦称“古陶”、“平陶” 。境内的中都,春秋时期就是晋国古邑，战国时属赵。秦始置平陶县,西汉置中都县和京陵县,北魏初废,改为平遥县。2700多年来,平遥虽一直是座县城，然而它在政治、经济和文化诸方面却有过辉煌。       平遥古城内的面积为2.25平方公里 ,分布着100多条纵横交错的大街小巷,街巷两边坐落着15世纪以来建造的两层楼的商业店铺、四合院民居和宏伟的庙宇建筑。城内还保存有10世纪以来的众多古建筑和文物珍品，这些都是平遥古城历史文化的重要组成部分。它们对研究中国明清以来城市建筑、人类居住形式和传统的文化发展有重要的艺术价值和科学价值。        据专家们研究 ,平遥古城方正端庄,体现了汉民族传统的“礼制”。因为县城的规模严守方三里这一”礼” 序等级。城的东西北三面城墙基本是直线,只有南面城墙中部向北微缩,曲若龟状。城内的大街小巷交错,似龟背的纹路,所以平遥古城也被人们称为龟城。龟城象征固若金汤,吉祥长存。       城墙上的构筑也富有寓意。 相传孔子周游列国时,收有72贤人，3000弟子。城墙上的3000个垛口象征着3000弟子,每座敌楼象征一位贤人。据说72贤人中由于子路崇尚武力,被孔子列入另册,所以这里只修了71座敌楼，在余下的那座敌楼台的位置上后人建了座奎星楼。',
    addressOne:'邮寄地址1',
    addressTwo:'邮寄地址2',
    zipCode:'邮编',
    domestic:'国内',
    international:'国际',
    Fax:'咨询电话（传真）',
    Cooperation:'商务与合作',
    PingyaoExhibition:'2020第20届中国平遥国际摄影大展',
    PromotionWork:'招商工作全面启动',
    pingyaoIntroOne:'平遥国际摄影大展(PIP)是由山西省委宣传部、省文化和旅游厅、中共晋中市委、市人民政府主办；中共平遥县委、县人民政府、平遥古城国际摄影大展有限公司承办。大展从2001年创办至今，一直秉承国际规范操作，国内与国际接轨、传统与现代互动，在海外产生了巨大的轰动和影响。曾荣获“IFEA中国最具国际影响力十大节庆活动”奖，被誉为“国际摄影师展示自己的珍贵舞台”。',
    pingyaoIntroTwo:'2020第20届平遥国际摄影大展将于9月19日正式开幕，本届展览首次采取“线上+线下”模式，将有 200余家专业媒体、门户网站等全方位整合传播，将为企业提供强大的宣传空间。本届大展我们提供形式多样的合作项目，包括：冠名权；展位、展厅、广告牌；合作伙伴；相关印刷品广告；网站；颁奖晚会等六大门类。如今，招商工作已全面启动，我们致力搭建国际知名企业品牌宣传的优质平台。诚邀各大企业加盟合作，求实共赢！',
    BusinessCooper:'商业合作咨询',
    downLoading:'2020年平遥感觉摄影大展招商文件下载',
    top:'顶部',
    mall:'商城',
    weibo:'微博',
    WeChat:'微信',
    Online:'线上报名',
    Offline:'线下报名',
	nameMessage:'请填写姓名',
	provinceMessage:'请填写地址',
	label_message:'请选择展览标签',
	idcardmessage:'请输入您的身份证号码',
	phoneMessage:'请填写您的手机号码',
	emailmessage:'请填写您的邮箱地址',
	htmlmessage:'请填写您的艺术履历',
  goUpto:'直接前往'
  },
  user: {
    login: 'login',
    register: 'register',
    loginUsername: 'please input email or phone',
  }
}



// WEBPACK FOOTER //
// ./src/utils/en.js